<template>
  <div
    class="HeaderSecondary"
    :class="style"
  >
    <div class="grid">
      <div class="col-1-1 flex justify-end sm-justify-center">
        <nav class="top-nav">
          <ul class="no-bullets nav-list flex flex-nowrap align-center">
            <li
              v-show="style === 'desktop'"
              class="nav-list-item"
            >
              <UILinkComponent
                :to="'/'"
                aria-label="Naar account"
                class="btn btn-ghost no-animation nav-item"
              >
                <UIIconComponent :icon="'user'" />
                <span class="text">Account</span>
              </UILinkComponent>
            </li>
            <li class="nav-list-item">
              <AccessibilitySelector
                :type="style !== 'mobile' ? 'list' : 'menu'"
                class="accessibility-menu"
                :options="[accessibilityOptions.stimulus, accessibilityOptions.size]"
              />
            </li>
            <li
              v-if="isMultiLanguage"
              class="nav-list-item"
            >
              <button
                v-for="language in languages"
                v-show="language.name !== currentLanguage.name"
                :key="language.name"
                class="menu-item lang-toggle-btn nav-item"
                :class="{ inactive: language.name !== currentLanguage.name }"
                @click="redirectToLanguage(language)"
              >
                <UIIconComponent :icon="'translate'" />
                <span class="text">
                  {{ language.title }}
                </span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { Navigation, Language } from '@tc8l/nuxt-base'

  const props = defineProps<{
    style?: 'mobile' | 'desktop'
  }>()

  const { accessibilityOptions } = useBaseAccessibility()

  const navigation = ref<Navigation[]>(await baseGetNavigationByGroup(20))

  const localization = useBaseLocalization()
  const currentLanguage = computed(() => localization.getCurrentLanguage())
  const isMultiLanguage = ref(localization.isMultiLanguage())
  const languages = ref(localization.getActiveLanguages())

  function redirectToLanguage(language: Language) {
    if (language.name === localization.getDefaultLanguage().name) {
      document.location = '/'
    } else {
      document.location = `/${language.name}`
    }
  }
</script>

<style lang="scss" scoped>
  .HeaderSecondary {
    background: #000;
    color: #fff;

    .nav-list {
      display: flex;
      gap: var(--margin-sm);
    }

    .nav-item,
    :deep(.accessibility-menu .menu-item),
    :deep(.TranslateMenu .nav-item) {
      display: flex;
      gap: 0.8rem;
      align-items: center;
      font-size: 1.4rem;
      min-height: unset;
      padding: 1.6rem 0;
      font-weight: 400;
      margin: 0;

      .icon {
        font-size: 1.6rem;
      }
    }

    &.mobile {
      background: unset;
      color: $color-text;

      .grid {
        padding: 0;

        .col-1-1 {
          padding: 0;
        }
      }
    }
  }
</style>
